import { Alert, Spinner } from "react-bootstrap";

import { useLocationDocument } from "../../api/firestoreWrappers.generated";

export default function MapOptimizationAlert({
    organizationId,
    locationId,
    className,
}) {
    const [location] = useLocationDocument(organizationId, locationId);
    const precomputeProgress =
        location?.routePlanner?.precomputeProgress ?? 1.0;
    const isPrecomputing = precomputeProgress < 1.0;

    return isPrecomputing ? (
        <Alert variant="warning" className={className}>
            <Spinner
                animation="border"
                variant="warning"
                size="sm"
                className="me-2"
            />{" "}
            Optimizing map. This will take a few seconds.
        </Alert>
    ) : null;
}
